import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    errorMessage: string;
    toastDetails: ({ totalBytesDownloaded, totalBytes }) => string;
    toastTitle: (n: number) => string;
    toastTitleComplete: (n: number) => string;
    toastTitleCanceled: (n: number) => string;
    toastTitlePartialComplete: (n: number, total: number) => string;
    seeDetails: string;
    detailsDialogTitle: string;
    dialogCloseLabel: string;
    successfulImports: (n: number) => string;
    failedImports: (n: number) => string;
    showFileOnDisk: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.errorMessage?c=3mt1oc3k5cqdv", defaultMessage: "Error importing assets" }));
                },
                enumerable: true,
                configurable: true
            },
            toastDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ totalBytesDownloaded = "\u2026", totalBytes = "\u2026" }): string => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.toastDetails?c=7ehb8n42res1", defaultMessage: "{totalBytesDownloaded} of {totalBytes}" }, { totalBytesDownloaded: totalBytesDownloaded, totalBytes: totalBytes }));
                },
                enumerable: true,
                configurable: true
            },
            toastTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (n: number): string => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.toastTitle?c=1mdtbumzn4s3r", defaultMessage: "{n, plural, other {Importing {n} Assets} one {Importing Asset}}" }, { n: n }));
                },
                enumerable: true,
                configurable: true
            },
            toastTitleComplete: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (n: number): string => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.toastTitleComplete?c=3ou6c942qpx1u", defaultMessage: "{n, plural, other {Imported {n} Assets} one {Imported Asset}}" }, { n: n }));
                },
                enumerable: true,
                configurable: true
            },
            toastTitleCanceled: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (n: number): string => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.toastTitleCanceled?c=24v4ed9k43ns2", defaultMessage: "{n, plural, other {Import Canceled for {n} Assets} one {Import Canceled}}" }, { n: n }));
                },
                enumerable: true,
                configurable: true
            },
            toastTitlePartialComplete: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (n: number, total: number): string => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.toastTitlePartialComplete?c=1kjxxo9qrc53f", defaultMessage: "{n, plural, one {Import Partially Complete} other {Import failed for {n} of {total} assets}}" }, { n: n, total: total }));
                },
                enumerable: true,
                configurable: true
            },
            seeDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.seeDetails?c=2ey9q70qz62py", defaultMessage: "Details" }));
                },
                enumerable: true,
                configurable: true
            },
            detailsDialogTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.detailsDialogTitle?c=3abt1etevqrqg", defaultMessage: "Import Details" }));
                },
                enumerable: true,
                configurable: true
            },
            dialogCloseLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.dialogCloseLabel?c=2g2kiprif3vje", defaultMessage: "Close Dialog" }));
                },
                enumerable: true,
                configurable: true
            },
            successfulImports: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (n: number): string => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.successfulImports?c=2zahubt616ed6", defaultMessage: "{n, plural, other {{n} Successful Imports} one {{n} Successful Import}}" }, { n: n }));
                },
                enumerable: true,
                configurable: true
            },
            failedImports: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (n: number): string => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.failedImports?c=2vw8oisli15wg", defaultMessage: "{n, plural, other {{n} Failed Imports} one {{n} Failed Import}}" }, { n: n }));
                },
                enumerable: true,
                configurable: true
            },
            showFileOnDisk: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useImportAssetsToPremiere.showFileOnDisk?c=3rfstcq2ws28t", defaultMessage: "Show in Finder" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
